var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('bq-header',{ref:"appHeader"}),_c('div',{staticClass:"bq-content"},[_c('router-view')],1),_c('bq-footer',{ref:"appFooter"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }